import { TimePeriodPicker } from "../../components/TimePeriodPicker/TimePeriodPicker";
import { useAuth } from "../../contexts/AuthContext";

import "./Home.css";
import Logo from "../../components/Logo/Logo";
import { User, Briefcase, Calculator, OctagonAlert, MessageSquare } from "lucide-react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import NavItem from "../../components/NavItem/NavItem";
import { Link } from "react-router-dom";

function Home() {
  const { unauthorized, authLoading, isSupervisor, isFinanceMember } = useAuth();

  return (
    <>
      <title>Projektkontrolle - Home</title>
      <LoadingSpinner loading={authLoading} text="Du wirst gerade eingeloggt" />
      <div className="home-container">
        <Logo />

        <div className="feedback-buttons">
          <Link to="/feedback" className="feedback-button">
            <MessageSquare size={16} />
            Feedback
          </Link>
        </div>

        <div className="top-section">
          <h1 className="page-title">Projektkontrolle</h1>
          <h2 className="page-subtitle">Zeitraum wählen:</h2>
          <div className="timepicker-container">
            <TimePeriodPicker />
          </div>
        </div>

        <div className="bottom-section">
          {!authLoading && (
            <div className="navigation-icons">
              {isSupervisor === true ? (
                <NavItem destination="/supervisor" icon={Briefcase} label="Vorgesetzter" />
              ) : (
                <div />
              )}

              {unauthorized ? (
                <NavItem
                  destination="/"
                  icon={OctagonAlert}
                  label="Dein user ist noch nicht erfasst."
                />
              ) : (
                <NavItem destination="/manager-check" icon={User} label="Projektleiter" />
              )}

              {isFinanceMember === true ? (
                <NavItem destination="/finance" icon={Calculator} label="Buchhaltung" />
              ) : (
                <div />
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Home;
